// Review progress for Flashcards, kept apart from the cards themselves:
//   revault:fc-sched  { v: 1, c: { [cardId]: { due, st, df, sd, r, l, k, ls, lr } } }   (no entry = New)
//   revault:fc-log    [[cardId, ts, rating, kBefore, q?], ...]   newest last, at most LOG_MAX
// Older code only knows revault:flashcards and writes it whole, so it can never reset progress here.
// Every write reads the stored value fresh first; nothing keeps a copy to write back later.
import { readJSON, broadcast, save as put } from "../shared/store.js";
import { entry } from "../shared/fc-due.js";

export const SCHED_KEY = "revault:fc-sched";
export const LOG_KEY = "revault:fc-log";
export const LOG_MAX = 2000;
// A schedule whose card is gone (and not just still arriving from another device) is dropped
// once its last review is this old.
const ORPHAN_MS = 60 * 864e5;

export function loadSched() {
	const raw = readJSON(SCHED_KEY, null);
	const c = {};
	if (raw && raw.c && typeof raw.c === "object") for (const id of Object.keys(raw.c)) { const e = entry(raw.c[id]); if (e) c[id] = e; }
	return { v: 1, c };
}
const logOk = (e) => Array.isArray(e) && typeof e[0] === "string" && Number.isFinite(e[1]) && Number.isInteger(e[2]) && Number.isInteger(e[3]);
export function loadLog() { const v = readJSON(LOG_KEY, []); return Array.isArray(v) ? v.filter(logOk) : []; }

// Saves review results: sets: { [cardId]: entry | null }, logs: new log rows. cardIds (optional)
// is every card that exists, used to drop old orphans.
export function record(sets, logs, cardIds) {
	const s = loadSched();
	for (const id of Object.keys(sets || {})) { if (sets[id]) s.c[id] = sets[id]; else delete s.c[id]; }
	if (cardIds) { const now = Date.now(); for (const id of Object.keys(s.c)) if (!cardIds.has(id) && (s.c[id].lr || 0) < now - ORPHAN_MS) delete s.c[id]; }
	// Log first: if the schedule then can't be saved, the log goes back to how it was, so the
	// New-card pace never counts a review that didn't happen.
	let before = null;
	if (logs && logs.length) {
		try { before = localStorage.getItem(LOG_KEY); } catch { /* storage off */ }
		const log = loadLog().concat(logs);
		log.sort((a, b) => a[1] - b[1]);
		if (!put(LOG_KEY, log.slice(-LOG_MAX))) return false;
	}
	if (put(SCHED_KEY, s)) return true;
	if (logs && logs.length) {
		try { if (before == null) localStorage.removeItem(LOG_KEY); else localStorage.setItem(LOG_KEY, before); } catch { /* nothing more to do */ }
		broadcast(LOG_KEY);
	}
	return false;
}

// Cards deleted from a deck lose their progress too.
export function dropCards(ids) {
	const s = loadSched();
	let hit = false;
	for (const id of ids) if (s.c[id]) { delete s.c[id]; hit = true; }
	return hit ? put(SCHED_KEY, s) : true;
}
